import React from "react";
import { Button } from "@mui/material";

import HoverText from "modules/documents/components/action-buttons/hoverText";
import LoadingCircle from "modules/common/components/loadingCircle";
import ChipListInput from "modules/common/components/chipListInput";
import isValidPhoneNumber from "utils/isValidPhoneNumber";

import "./styles/smsSettingsPanel.sass";

export const MAX_SMS_FOR_TEST = 10;

interface ISendTestSmsInputProps {
    testNumbers: string[];
    isSendingTestSMS: boolean;
    sendTestSMSDisabled: boolean;
    onClickSendTestSMS: () => void;
    setNumbersForTest: (numbers: string[]) => void;
}

const SendTestSmsInput: React.FC<ISendTestSmsInputProps> = ({
    testNumbers,
    isSendingTestSMS,
    sendTestSMSDisabled,
    onClickSendTestSMS,
    setNumbersForTest
}) => {
    const verifyNewPhoneNumber = (number: string): boolean => {
        const trimmedNumber = number.replaceAll(/[^0-9]/g, '');
        const trimmedExistingEntries = testNumbers.map(num => num.replaceAll(/[^0-9]/g, ''));

        const numberAlreadyExists = trimmedExistingEntries.includes(trimmedNumber);
        return isValidPhoneNumber(number) && !numberAlreadyExists;
    }

    return <div className="send-test-sms-container">
        <div className="send-test-sms-label-button-container">
            <HoverText label="Send test SMS" labelContainerClassName="hover-text-container">
                Send test messages to preview how your message will appear to recipients. 
            </HoverText>
            <div className="send-test-sms-loading-button-container">
                { isSendingTestSMS && <LoadingCircle size="16px" style={{ marginRight: 4 }}/> }
                <Button 
                    variant="outlined" 
                    disabled={testNumbers.length === 0 || isSendingTestSMS || sendTestSMSDisabled}
                    onClick={onClickSendTestSMS}
                >
                    Send test SMS
                </Button>
            </div>
        </div>
        <ChipListInput
            values={testNumbers}
            onRemoveChip={removedNumber => setNumbersForTest(testNumbers.filter(num => num !== removedNumber))}
            onAddValidatedChips={validNumbers => setNumbersForTest([...testNumbers, ...validNumbers].slice(0, MAX_SMS_FOR_TEST))}
            errorProps={{
                isValueValid: verifyNewPhoneNumber,
                errorHelperText: "Enter valid mobile number"
            }}
            helperText={<i>Press Enter or comma (,) after each mobile number.</i>}
            textFieldProps={{
                className: "test-sms-address-text-field",
                size: "small",
                placeholder: `Enter up to ${MAX_SMS_FOR_TEST} mobile numbers`,
                FormHelperTextProps: { sx: { marginLeft: 0 }},
                disabled: testNumbers.length >= MAX_SMS_FOR_TEST
            }}
            chipClassName="test-sms-chip"
            containerSx={{ overflow: "auto" }}
        />
    </div>;
};

export default SendTestSmsInput;
